import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// ------------ Firebase Inicio
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDt-LqikURjc8CHxXgjeuL6B8sKNUvknJg",
  authDomain: "tortoneautomotores-b9f5f.firebaseapp.com",
  projectId: "tortoneautomotores-b9f5f",
  storageBucket: "tortoneautomotores-b9f5f.appspot.com",
  messagingSenderId: "967714168093",
  appId: "1:967714168093:web:ea53ee176b2253b3cd15f4",
  measurementId: "G-8HLMPHC7SW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// ------------ Firebase Fin

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
